import { SelectsList, handleOptions } from '../forms/select/handlers';
import setLoadMore from './load-more';

function setDefault(buttons, mobile) {
  const params = new URLSearchParams(window.location.search);
  const category = params.get('category') || null;

  let target = null;

  if (!category) {
    // eslint-disable-next-line prefer-destructuring
    target = buttons.filter((button) => !button.getAttribute('value'))[0];
  } else {
    // eslint-disable-next-line prefer-destructuring
    target = buttons.filter((button) => button.getAttribute('value') === category)[0];
  }

  buttons.forEach((button) => {
    if (button !== target) {
      button.classList.remove('active');
    } else {
      button.classList.add('active');
      button.setAttribute('disabled', true);
    }
  });

  if (mobile) {
    const option = mobile.options.filter(
      (item) => item.dataset && item.dataset.value === category
    )[0];

    const all = mobile.options.filter((item) => !item.dataset || !item.dataset.value)[0];

    if (option) {
      mobile.value = { text: option.textContent, value: category };
    } else {
      mobile.value = { text: all.textContent, value: '' };
    }
  }
}

function handleForm(className, mobile) {
  const form = document.querySelector(`${className}-filter.mobile`);
  if (!form) return;

  const input = form.querySelector('input');
  if (!input) return;

  const previous = input.value;

  handleOptions(mobile, { form, previous });
}

export default function setupBlog(className) {
  if (!document.querySelector(className)) return;

  const filter = document.querySelector(`${className}-filter.desktop`);
  if (!filter) return;

  const mobile = SelectsList.filter((item) =>
    item.select.classList.contains('site-select-filter')
  )[0];

  const buttons = filter.querySelectorAll(`${className}-filter--button`);
  if (!buttons || !buttons.length) return;

  setDefault([...buttons], mobile);
  setLoadMore('.alm-load-more-btn');

  if (mobile) handleForm(className, mobile);
}
